var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBillingAccountInfoNormal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Billing_Account_Info_Normal"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Billing_Account_Info_Normal",
    "data-name": "Billing Account Info_Normal",
    clipPath: "url(#clip-Billing_Account_Info_Normal)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Billing_Account_Info",
    "data-name": "Billing Account Info",
    transform: "translate(1 3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_36",
    "data-name": "Subtraction 36",
    d: "M-931.536-581.591h-13.878v-16.644L-948-604h18.931a2.08,2.08,0,0,1,2.086,2.068v12.875H-927a6.914,6.914,0,0,0-3.4.944c-1.5.958-2.23,4.718-2.237,4.756l1.1,1.765Zm-9.948-4a.572.572,0,0,0-.572.572.572.572,0,0,0,.572.571h4.872a.572.572,0,0,0,.571-.571.572.572,0,0,0-.571-.572Zm-.009-3.928a.572.572,0,0,0-.571.571.572.572,0,0,0,.571.571h7.1a.572.572,0,0,0,.571-.571.572.572,0,0,0-.571-.571Zm-.016-3.928a.572.572,0,0,0-.572.571.572.572,0,0,0,.572.572h10.373a.572.572,0,0,0,.571-.572.572.572,0,0,0-.571-.571Zm1.051-6.669h0l-.014.014v4.058h1.014c.721,0,1.043-.326,1.043-1.057v-.328c0-.588-.286-.721-.457-.8.172-.062.4-.21.4-.8v-.158c0-.625-.336-.929-1.029-.929Zm7.516,0v4.058h1.686l.071-.686h-.986v-3.372Zm-2.6,0v4.058h1.687l.071-.686h-.986v-3.372Zm-1.872,0v4.058h.772v-4.058Zm-2.314,3.473V-597.9h.114c.3,0,.4.112.4.443v.373c0,.29-.051.428-.343.428h-.157l-.012.013Zm.157-1.858h-.129v-.986h.143c.236,0,.328.1.328.371v.2c0,.3-.087.4-.357.4l.013.013Z",
    transform: "translate(951.287 604.557)",
    fill: "#6f8b8f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2092",
    "data-name": "Group 2092",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4598",
    "data-name": "Path 4598",
    d: "M8.488,7.11h0A2.929,2.929,0,0,0,5.83,10.239v3.129h5.3V10.239A2.919,2.919,0,0,0,8.473,7.11Z",
    transform: "translate(-5.258 -6.553)",
    fill: "#6f8b8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4599",
    "data-name": "Path 4599",
    d: "M11.3,14.121H6a.573.573,0,0,1-.572-.572V10.421a3.488,3.488,0,0,1,3.229-3.7,3.488,3.488,0,0,1,3.229,3.7V13.55a.573.573,0,0,1-.572.572ZM6.587,12.964h4.144V10.406A2.353,2.353,0,0,0,8.659,7.849a2.353,2.353,0,0,0-2.072,2.558Z",
    transform: "translate(-5.43 -6.72)",
    fill: "#6f8b8f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4607",
    "data-name": "Path 4607",
    d: "M9.712,17.806a.573.573,0,0,1-.572-.572V11.362a.572.572,0,1,1,1.143,0v5.872A.573.573,0,0,1,9.712,17.806Z",
    transform: "translate(-3.879 -5.033)",
    fill: "#6f8b8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4608",
    "data-name": "Path 4608",
    d: "M24.39,30.273c.058-.114-13.9,0-13.9,0a.571.571,0,0,1-.572-.567V23.513a.572.572,0,0,1,1.143,0v5.626s12.206.019,12.273,0c0,0-1.2-1.686.4-4.686s4.133-2.6,4.133-2.6c0,.267.469-12.5.469-12.5a1.509,1.509,0,0,0-1.515-1.5H7.9a.567.567,0,1,1,0-1.134H26.833a2.651,2.651,0,0,1,2.658,2.636s.041,12.3,0,12.5-3.826.5-5.1,2.6S24.332,30.387,24.39,30.273Z",
    transform: "translate(-4.615 -6.72)",
    fill: "#6f8b8f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2095",
    "data-name": "Group 2095",
    transform: "translate(18.223 14.563)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2094",
    "data-name": "Group 2094"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_112",
    "data-name": "Ellipse 112",
    transform: "translate(0.277 0.437)",
    fill: "none",
    stroke: "#6f8b8f",
    strokeWidth: 1.2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 5.4,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_4610",
    "data-name": "Path 4610",
    d: "M23.317,20.99v3.029H21.96V20.99h1.357Z",
    transform: "translate(-16.383 -14.81)",
    fill: "#6f8b8f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_77",
    "data-name": "Ellipse 77",
    cx: 0.829,
    cy: 0.829,
    r: 0.829,
    transform: "translate(5.448 3.665)",
    fill: "#6f8b8f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4611",
    "data-name": "Path 4611",
    d: "M9.712,17.935a.573.573,0,0,1-.572-.572v-.371a.572.572,0,1,1,1.143,0v.371A.573.573,0,0,1,9.712,17.935Z",
    transform: "translate(-3.879 -2.668)",
    fill: "#6f8b8f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillingAccountInfoNormal);
export default __webpack_public_path__ + "static/media/Billing_Account_Info_Normal.98e1f821b5210013e43fbe80bccddafc.svg";
export { ForwardRef as ReactComponent };